export default __webpack_public_path__ + "static/media/HeroImageError.037d0032.svg";